export default __webpack_public_path__ + "1232108a7470dd3fa3be74c31baed667.png";